var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import { getIconConfigForHref } from '../../utilities/get-icon-config-for-href';
import { LinkAnchor, LinkContainer, LinkIcon, LinkLabel, LinkSubText } from './styles/_link.styled';
export const Link = forwardRef(function LinkWithRef(_a, ref) {
    var { children, href, sub, onClick, variant = 'button-link', icon, disableIcon, iconInverted, onMouseEnter, dataTest = 'link', colorInverted = false, visualOnly = false, className } = _a, props = __rest(_a, ["children", "href", "sub", "onClick", "variant", "icon", "disableIcon", "iconInverted", "onMouseEnter", "dataTest", "colorInverted", "visualOnly", "className"]);
    const { iconVariant: tempIconVariant, isInternalLink } = href
        ? getIconConfigForHref({
            href,
        })
        : {
            iconVariant: 'arrow-right',
            isInternalLink: true,
        };
    const iconVariant = icon || tempIconVariant;
    return (_jsx(LinkContainer, { "data-test": dataTest, className: className, children: _jsxs(LinkAnchor, Object.assign({ as: visualOnly ? 'span' : 'a', href: visualOnly ? undefined : href, onClick: onClick, onMouseEnter: onMouseEnter, "$iconInverted": iconInverted, "$colorInverted": colorInverted }, (!isInternalLink
            ? {
                target: '_blank',
                rel: 'noopener',
            }
            : {}), (href === undefined
            ? {
                role: 'button',
                tabIndex: 0,
                onKeyPress: (event) => event.key === 'Enter' && onClick && onClick(event),
            }
            : {}), props, { ref: ref, children: [_jsxs(LinkLabel, { tagName: "span", variant: variant, dataTest: `${dataTest}-text`, children: [children, !disableIcon && !iconInverted && (_jsx(LinkIcon, { variant: iconVariant, className: "PONCHO-link__icon", dataTest: `${dataTest}-icon` }))] }), !disableIcon && iconInverted && (_jsx(LinkIcon, { variant: iconVariant, className: "PONCHO-link__icon", dataTest: `${dataTest}-icon` })), sub && (_jsx(LinkSubText, { tagName: "small", className: "PONCHO-link__sub", dataTest: `${dataTest}-sub-text`, children: sub }, "small"))] })) }));
});
export default Link;
